module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_suns-ce744e5ab822d62fdee7a1ce5539340f.webp";